<template>
  <div>
    <div v-if="isInvitingAttendee">
      <v-form ref="bulkEmailForm" @keydown.enter="$event.preventDefault()">
        <!---Start: Added because one input field always submits form on pressing enter,
        refer to https://stackoverflow.com/questions/1370021/why-does-forms-with-single-input-field-submit-upon-pressing-enter-key-in-input
        ---->
        <input type="text" style="display: none" />
        <!---End: Added because one input field always submits form on pressing enter--->
        <v-row>
          <v-col cols="9">
            <v-text-field
              outlined
              dense
              multiline
              :value="value"
              @input.native="$emit('input', $event.target.value)"
              :rules="emailRules"
              @blur="handleInnerTextFieldBlur"
              placeholder="Type email..."
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-btn
              width="90"
              color="primary lighten--3"
              depressed
              type="button"
              @click="handleChange"
              class="text-body-1 primary"
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
      <template v-if="splitEmails.length > 0">
        <v-chip
          dark
          v-for="(email, index) in splitEmails"
          :key="email"
          class="my-2 mr-2"
          close
          @click:close="handleRemove(index)"
        >
          <!-- <UserAvatar :usersInitials="email[0]" /> -->
          <v-avatar left class="primary lighten-2 text-uppercase" light>
            {{ email[0] }}
          </v-avatar>
          {{ email }}</v-chip
        >
      </template>
      <div v-else>
        <!-- No emails were found. You can add multiple emails by pasting them
            from your spreadsheet directly. -->
      </div>

      <v-row no-gutters class="mt-8">
        <v-col cols="12" class="text-right pr-0">
          <v-btn
            color="primary"
            large
            width="200"
            type="button"
            depressed
            @click="handleSendEmails"
            :disabled="splitEmails.length < 1"
          >
            {{ sendButtonText }}
          </v-btn>
        </v-col>
        <!-- <v-col cols="12">
              <v-btn
                text
                block
                depressed
                large
                @click="handleCloseBulkEmailDialog"
              >
                Cancel
              </v-btn>
            </v-col> -->
      </v-row>
    </div>

    <template v-else>
      <v-form ref="bulkEmailForm">
        <v-text-field
          outlined
          dense
          multiline
          :value="value"
          @input.native="$emit('input', $event.target.value)"
          @keyup="handleChange"
          :rules="emailRules"
          @blur="handleBlur"
          placeholder="Type email..."
        ></v-text-field>
      </v-form>

      <v-dialog v-model="showDialog" width="500" persistent>
        <v-card height="100%">
          <v-card-title class="d-flex justify-space-between"
            ><div>Send invitation in bulk</div>
            <v-btn fab icon small @click="handleCloseBulkEmailDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            ></v-card-title
          >
          <v-card-subtitle>
            <div>
              Paste all emails from your spreadsheet or list, or add more.
            </div>
            <div>Total: {{ this.splitEmails.length }}</div>
          </v-card-subtitle>
          <v-card-text>
            <v-form ref="bulkEmailForm">
              <v-row>
                <v-col cols="9">
                  <v-text-field
                    outlined
                    dense
                    multiline
                    :value="value"
                    @input.native="$emit('input', $event.target.value)"
                    :rules="emailRules"
                    @blur="handleInnerTextFieldBlur"
                    placeholder="Type email..."
                  ></v-text-field>
                </v-col>
                <v-col cols="3" class="text-right">
                  <v-btn
                    width="90"
                    color="primary lighten--3"
                    depressed
                    @click="handleChange"
                    class="text-body-1 primary"
                    >Add</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
            <template v-if="splitEmails.length > 0">
              <v-chip
                dark
                v-for="(email, index) in splitEmails"
                :key="email"
                class="my-2 mr-2"
                close
                @click:close="handleRemove(index)"
              >
                <!-- <UserAvatar :usersInitials="email[0]" /> -->
                <v-avatar left class="primary lighten-2 text-uppercase" light>
                  {{ email[0] }}
                </v-avatar>
                {{ email }}</v-chip
              >
            </template>
            <div v-else>
              <!-- No emails were found. You can add multiple emails by pasting them
            from your spreadsheet directly. -->
            </div>

            <v-row no-gutters class="mt-8">
              <v-col cols="12" class="text-right pr-0">
                <v-btn
                  color="primary"
                  large
                  width="200"
                  depressed
                  @click="handleSendEmails"
                  :disabled="splitEmails.length < 1"
                >
                  {{ sendButtonText }}
                </v-btn>
              </v-col>
              <!-- <v-col cols="12">
              <v-btn
                text
                block
                depressed
                large
                @click="handleCloseBulkEmailDialog"
              >
                Cancel
              </v-btn>
            </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import { mapGetters } from "vuex";

export default {
  props: {
    value: { type: String },
    showBulkEmailDialog: { type: Boolean, default: false },
    isInvitingAttendee: { type: Boolean, default: false },
  },
  components: {
    UserAvatar,
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    sendButtonText() {
      if (this.splitEmails.length == 1)
        return `Send ${this.splitEmails.length} invitation`;
      else return `Send ${this.splitEmails.length} invitations`;
    },
  },
  watch: {
    isFormValid: function () {
      if (this.isFormValid) {
        this.$emit("disable-add", false);
      } else {
        this.$emit("disable-add", true);
      }
    },
    value: function () {
      this.isFormValid = this.$refs.bulkEmailForm.validate();
      //   this.$refs.bulkEmailForm.resetValidations();
    },
    showBulkEmailDialog: function (newValue) {
      if (newValue) this.showDialog = newValue;
    },
  },
  data() {
    return {
      autoUpdate: true,
      errorMessage: "",
      emails: "",
      splitEmails: [],
      showDialog: false,
      emailRules: [(v) => this.isEmailValid(v)],
      isFormValid: false,
    };
  },
  methods: {
    isEmailValid(email) {
      console.log("checking...");
      if (!email) {
        this.errorMessage = "Please enter a valid email";
        // return false;
        return this.errorMessage;
      }
      if (
        this.currentEvent.invitees.some((invitee) => invitee.email == email)
      ) {
        console.log("invited already err msg");
        this.errorMessage = "This email has already received an invitation";
        // return false;
        return this.errorMessage;
      }

      if (email.length <= 255) {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.errorMessage = "";
          return true;
        }
        console.log("check 2");
        this.errorMessage = "Please enter a valid email";
        // return false;
        return this.errorMessage;
      } else {
        console.log("check 3");
        this.errorMessage = "Please enter a valid email";
        // return false;
        return this.errorMessage;
      }
    },
    handleRemove(index) {
      //   this.splitEmails = this.splitEmails.filter(
      //     (email) => email != selectedEmail
      //   );
      this.splitEmails.splice(index, 1);
    },
    handleSendEmails() {
      this.$emit("clear");
      this.showDialog = false;
      this.$emit("email-added", this.splitEmails);
      this.$emit("close-bulk-email-dialog");
      //Start:Clear split emails
      this.splitEmails = [];
      //End: Clear split email
    },
    handleChange() {
      this.getSplitEmails(this.value);

      console.log("splitEmails: ", this.splitEmails);
      if (this.splitEmails.length > 1) {
        if (!this.showDialog) this.showDialog = true;
        this.resetForm();
        this.$emit("clear");
      } else if (
        this.splitEmails.length == 1 &&
        //check if email hasn't been invited already
        !this.currentEvent.invitees.some(
          (invitee) => invitee.email == this.value
        ) &&
        this.isEmailValid(this.value)
      ) {
        this.showDialog = false;
        this.$emit("disable-add", false);

        // this.$emit("close-bulk-email-dialog");
        // this.resetForm();
        // this.$emit("clear");
      } else {
        this.showDialog = false;
        this.$emit("disable-add", true);

        // this.$emit("close-bulk-email-dialog");
        // this.resetForm();
        // this.$emit("clear");
      }
    },
    validateEmail() {
      this.isFormValid = this.$refs.bulkEmailForm.validate();
    },
    handleBlur() {
      this.$refs.bulkEmailForm.resetValidation();
    },
    resetForm() {
      this.$refs.bulkEmailForm.reset();
    },
    handleCloseBulkEmailDialog() {
      this.showDialog = false;
      this.$emit("close-bulk-email-dialog");
      this.resetForm();
      this.$emit("clear");
    },
    handleInnerTextFieldBlur() {
      // this.getSplitEmails(this.value);
    },
    handleInputEmailBlur(event) {
      console.log("event: ", event.target.value);
      if (
        //check if email hasn't been invited already
        this.currentEvent.invitees.some(
          (invitee) => invitee.email == event.target.value
        ) &&
        this.isEmailValid(this.value)
      ) {
        console.log("Email has been invited already");
      }
    },
    getSplitEmails(value) {
      let splitEmails = value.split(/[\s\t\n,+,+]/);
      this.splitEmails = [];
      splitEmails.forEach((email) => {
        if (
          this.isEmailValid(email) &&
          !this.currentEvent.invitees.some(
            (invitee) => invitee.email == email
          ) &&
          this.splitEmails.indexOf(email) == -1
        ) {
          this.splitEmails.push(email);
        }
      });
    },
  },
};
</script>